import React, { useEffect, useLayoutEffect } from 'react';
import AppRoutes from './routes.js';
import './App.css';
import './shared/styles/variables.scss';
import './shared/styles/materialTable.scss';
import {
	ThemeProvider,
	StyledEngineProvider,
	createTheme,
} from '@mui/material/styles';
import LanguageSelector from './utils/LanguageSelector.js';
import { withTranslation } from 'react-i18next';
//REDUX
import { useDispatch } from 'react-redux';
import ACTIONS from './redux/action';
//import makeStyles from '@mui/styles/makeStyles';

import * as Sentry from '@sentry/react';

const theme = createTheme();

// const useStyles = makeStyles((theme) => {
//   root: {
//     // some CSS that accesses the theme
//   }
// });

// Test comment

function App() {
	const dispatch = useDispatch();

	// Capture referrer URL immediately using useLayoutEffect (runs synchronously before browser paint)
	// This ensures it's available before any child components mount and call their componentDidMount
	useLayoutEffect(() => {
		const referrer = document.referrer || '';
		console.log('[sourceUrl] Document referrer (useLayoutEffect):', referrer);
		if (referrer) {
			// Save to Redux store immediately
			dispatch(
				ACTIONS.addCompanyInfo({
					id: 'sourceUrl',
					data: referrer,
					stateObject: 'company_store',
				})
			);
			console.log(
				'[sourceUrl] Saved to Redux store (useLayoutEffect):',
				referrer
			);

			// Send to dataLayer
			if (window.dataLayer) {
				window.dataLayer.push({
					event: 'sourceUrl_captured',
					sourceUrl: referrer,
				});
				console.log(
					'[sourceUrl] Sent to dataLayer (useLayoutEffect):',
					referrer
				);
			}
		} else {
			console.log(
				'[sourceUrl] No referrer found (direct navigation or bookmark)'
			);
		}
	}, [dispatch]); // Only run once on mount

	return (
		<StyledEngineProvider injectFirst>
			<ThemeProvider theme={theme}>
				<div className="App">
					{/* <div className='langselector'>
            <LanguageSelector />
          </div> */}
					<AppRoutes />
				</div>
			</ThemeProvider>
		</StyledEngineProvider>
	);
}

export default Sentry.withProfiler(withTranslation()(App));
